import { Component, OnInit,Input } from '@angular/core';
import { AlertService } from "../../_services/alert.service";
import { SettingsService } from "../../_services/settings.service";
import { ReportsService } from "../../_services/reports.service";
import { Report, Sort, Summary } from "../../_models/report";
import { AuthenticationService } from "../../_services/authentication.service";

@Component({
  selector: 'reports',
  templateUrl: 'reports.html'
})

export class ReportsComponent implements OnInit {

  @Input() reportId = 0;

  bigData = this.rep.bigData;
  minLimit = new Date(2016, 10, 24);
  maxLimit = new Date();
  minDate = new Date();
  maxDate = new Date();
  sort = new Sort();
  sortd = new Sort();
  sortColumn = 0;
  filtered: Report[] = [];
  filtered1: Report[] = [];
  summary: Summary = new Summary();
  summaryd: Summary = new Summary();
  detaillevel = 0;
  currentCampaign = new Report();
  redraw = false;
  thirdMetric = "JoinType";
  fileDownload = "";

  constructor(private alert: AlertService, private set: SettingsService, private rep:ReportsService, public auth:AuthenticationService) {
    var d = new Date();
    d.setDate(d.getDate() - 1);
    this.maxDate = this.maxLimit = d;
    this.minDate.setFullYear(this.maxLimit.getFullYear() - 1);
    if (this.filtered.length == 0) {
      this.filter();
    }
  }

  public ngOnInit(): void {
    
  }

  runBig() {
    this.set.pageSettings.running = true;
    this.detaillevel = 0;
    this.rep.loadDefault(new Date(this.minDate),new Date(this.maxDate)).subscribe((res: Report[]) => {
      this.rep.bigData.topLevel = this.filtered = res;
      this.filter();
      this.set.pageSettings.running = false;
    });
  }
  runDetail(campaign?: Report) {
    if (!campaign) campaign = this.currentCampaign;
    this.set.pageSettings.running = true;
    this.rep.loadDetail(new Date(this.minDate), new Date(this.maxDate),campaign.Campaign).subscribe((res: Report[]) => {
      this.series = ["Cost", "Value"];
      this.currentCampaign = campaign;
      this.detaillevel = 1;
      this.rep.bigData.detail = this.filtered1 = res;
      this.filter();
      this.set.pageSettings.running = false;
    });
  }
  runDetailHour(campaign?: Report) {
    if (!campaign) campaign = this.currentCampaign;
    this.set.pageSettings.running = true;
    this.rep.loadDetailHour(new Date(this.minDate), new Date(this.maxDate), campaign.Campaign).subscribe((res: Report[]) => {
      this.series = ["Cost"];
      this.currentCampaign = campaign;
      this.detaillevel = 2;
      this.rep.bigData.detail = this.filtered1 = res;
      this.sortCol('Hour', true);
      this.filter();
      this.set.pageSettings.running = false;
    });
  }
  backToAll(detaillevel?:number) {
    this.detaillevel = 0;
    this.filter();
  }
  sortCol(property:string, auto?:boolean) {
    this.set.pageSettings.running = true;
    let sort = this.sort;

    if (this.detaillevel > 0) {
      sort = this.sortd;
    }
    if(!auto && sort.column==property) sort.isDesc = !sort.isDesc;    
    sort.column = property;
    let direction = sort.isDesc ? 1 : -1;
    let array = [];
    if (this.detaillevel==0) array = this.filtered;
    else array = this.filtered1;
    array.sort(function (a, b) {
      if (a[property] < b[property]) {
        return -1 * direction;
      }
      else if (a[property] > b[property]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
    this.set.pageSettings.running = false;
  };
  changeMetric(property: string) {
    this.thirdMetric = property;
    this.chartData();
  }
  filter() {
    let array: Report[] = [];
    var sumPos = 0;
    var avgPos = 0;

    var sort = this.sort;
    var data = this.bigData.topLevel;
    var summary = this.summary = new Summary();

    if (this.detaillevel>0) {
      sort = this.sortd;
      data = this.bigData.detail;
      summary = this.summaryd = new Summary();
    }
   
    data.forEach(rep => {
      let present = false;
      if (sort.joinFilter == "All" || rep.JoinType == sort.joinFilter) {
        if (sort.accFilter == "All" || rep.Account == sort.accFilter) {
          if (sort.camParFilter == "All" || rep.Partner == sort.camParFilter) {
            if (sort.camDevFilter == "All" || rep.Device == sort.camDevFilter) {
              if (sort.camIdFilter == "" || rep.CampaignId.toString().toLowerCase().includes(sort.camIdFilter.toLowerCase())) {
                //campaign filter
                present = true;
                if (sort.camFilter != "") {
                  let multi = sort.camFilter.split(' ');
                  multi.forEach(m => {
                    if (!rep.Campaign.toLowerCase().includes(m.toLowerCase())) {
                      present = false;
                    }
                  });
                }
              }
            }
          }
        }
      }
      if (present) {
        summary.records++;
        summary.totalValue += rep.Value;
        summary.totalCost += rep.Cost;
        summary.totalClicks += rep.Clicks;
        summary.totalImpressions += rep.Impressions;
        summary.totalLeads += rep.Leads;
        if (rep.Clicks > 0) {
          sumPos++;
          avgPos = rep.AvgPosition;
        }
        array.push(rep);
      }
    });
    summary.totalMargin = summary.totalValue - summary.totalCost;
    if (summary.totalValue == 0) summary.totalPercent = 0;
    else summary.totalPercent = summary.totalMargin / summary.totalValue * 100;
    if (sumPos == 0) summary.avgPos = 0;
    else summary.avgPos = avgPos / sumPos;
    if (summary.totalClicks == 0) summary.avgCPC = 0;
    else summary.avgCPC = summary.totalCost / summary.totalClicks;

    if (summary.totalLeads == 0) summary.totalCostPerLead = 0;
    else summary.totalCostPerLead = summary.totalCost / summary.totalLeads;

    if (this.detaillevel==0) {
      this.filtered = array;
    }
    else {
      this.filtered1 = array;
      this.chartData();
    }
    this.sortCol(this.sort.column,true);
  }
  setMin(d) {
    this.minDate = new Date(d);
  }
  setMax(d) {
    this.maxDate = new Date(d);
  }

  series: string[] = ["Cost","Value"];
  addToSeries(metric: string,which:number) {
    if (this.detaillevel == 2) this.series = [metric];
    else {
      let exists = this.series.indexOf(metric);
      if (exists >= 0) {
        this.series.splice(exists, 1);
      }
      else {
        this.series.push(metric);
      }
    }
    if (this.series.length == 0) this.series = ["Cost"];
    this.chartData();
  }

  summarize(records:Report[]) {
    let summ = []; 
    records.forEach((rep) => {
      let exists = false;
      summ.forEach((sum) => {
        if (sum.Hour == rep.Hour && sum.Metric==rep[this.thirdMetric]) {
          exists = true;
          sum.Value += rep.Value;
          sum.Cost += rep.Cost;
          sum.Margin += rep.Margin;
          sum.Clicks += rep.Clicks;
          sum.Impressions += rep.Impressions;
          sum.Leads += rep.Leads;
        }
      });
      if (!exists) {
        let sum = { Hour: rep.Hour,Metric:rep[this.thirdMetric], Value: rep.Value, Cost: rep.Cost, Margin: rep.Margin,MarginPer:0, Clicks: rep.Clicks, Impressions: rep.Impressions, AvgCPC: 0,Leads:rep.Leads };
        summ.push(sum);
      }
    });
    summ.forEach((sum) => {
      if (sum.Value > 0) {
        sum.MarginPer = (sum.Value - sum.Cost) / sum.Value * 100;
      }
      if (sum.Clicks > 0) {
        sum.AvgCPC = sum.Cost / sum.Clicks;
      }
      if (sum.Leads > 0) {
        sum.CostPerLead = sum.Cost / sum.Leads;
      }
    })
    return summ;
  }

  chartData() {
    this.redraw = true;
    this.lineChartOptions = {
      responsive: true
    };
    //if (this.filtered1.length > 0) {
      this.lineChartData = [];
      this.lineChartLabels = [];
      
      let sorted = this.filtered1.slice(0);
      if (this.detaillevel == 1) {
        this.series.forEach(met => {
        this.lineChartData.push({ data: [], label: met });
      });

        sorted.sort(function (a, b) {
          if (a.Date < b.Date) {
            return -1;
          }
          else if (a.Date > b.Date) {
            return 1;
          }
          else {
            return 0;
          }
        });
        sorted.forEach(rep => {
          this.lineChartData.forEach(datarow => {
            datarow.data.push(rep[datarow.label]);
          });
          if (this.detaillevel == 1) {
            let d = new Date(rep.Date);
            this.lineChartLabels.push(d.getDate() + ' ' + this.months[d.getMonth()] + ' ' + d.getFullYear().toString().substring(-2));
          }
          else if (this.detaillevel == 2) {
            this.lineChartLabels.push(rep.Hour);
          }
        });
        this.lineChartType = "line";
      }
      else if (this.detaillevel == 2) {

        let summ = this.summarize(sorted);
        
        summ.sort(function (a, b) {
          if (a.Hour < b.Hour) {
            return -1;
          }
          else if (a.Hour > b.Hour) {
            return 1;
          }
          else {
            return 0;
          }
        });
        summ.forEach((rec) => {
          let exists = false;

          this.lineChartData.forEach((lc) => {

            if (lc.label == rec.Metric) {
              exists = true;
              lc.data[rec.Hour]=rec[this.series[0]];
            }
          });
          if (!exists) {
            let data: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            data[rec.Hour] = rec[this.series[0]];
            let lc = { data: data, label: rec.Metric };
            this.lineChartData.push(lc);
          }

        });
        for (var x = 0; x < 24; x++) {
          this.lineChartLabels.push(x.toString());
        }
        this.lineChartType = "bar";
        this.lineChartOptions.scales = { xAxes: [{ stacked: true }] };
        this.lineChartOptions.scales = { yAxes: [{ stacked: true }] };
      }
 
    //}
    let scope = this;
    setTimeout(
      ()=>{
        scope.redraw = false;
      }, 100
    );
  }
  months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  public lineChartData: Array<any> = [];
  /*
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' },
    { data: [18, 48, 77, 9, 100, 27, 40], label: 'Series C' }
  ];*/

  public lineChartLabels: Array<any> = [];//['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartOptions: any = {
    responsive: true
  };
  public lineChartColors: Array<any> = [

    { // if
      backgroundColor: '#3489c8',
      borderColor: '#225275',
      pointBackgroundColor: '#3489c8',
      pointBorderColor: '#225275',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    { // purple
      backgroundColor: '#6d3978',
      borderColor: '#4a1156',
      pointBackgroundColor: '#6d3978',
      pointBorderColor: '#4a1156',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    { // green
      backgroundColor: '#3c6c4e',
      borderColor: '#103c21',
      pointBackgroundColor: '#3c6c4e',
      pointBorderColor: '#103c21',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    }
  ];
  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  runDownload() {
    this.fileDownload = "api/Report1csv?mindate=" + this.auth.dateParam(this.minDate) + "&maxdate=" + this.auth.dateParam(this.maxDate);
  }

  //api/Report1csv?mindate={{minDate | date:'yyyy-MM-dd'}}&maxdate={{maxDate | date:'yyyy-MM-dd'}}
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/components/reports/reports.ts